import { ReportLeadsState } from '../states';
import { reportLeadsActions } from '../actions';
import { ReportLeadsEntity } from '../entities';
import { reportLeadsAdapter, initialState } from '../adapters/report-leads.adapter';


export function reportLeadsReducer(state = initialState, action: reportLeadsActions.Actions): ReportLeadsState {
    switch (action.type) {

        case reportLeadsActions.ActionTypes.LOAD: {
            return {
                ...state,
                isLoaded: false,
                isLoading: true
            }
        }

        case reportLeadsActions.ActionTypes.LOAD_SUCCESS: {
            const entities = action.response.result.map(item => new ReportLeadsEntity(item));
            const newSate = reportLeadsAdapter.setAll(entities, state);
            return {
                ...newSate,
                isLoading: false,
                isLoaded: true,
                nextUrl: action.response.next,
                prevUrl: action.response.prev,
                totalCount: action.response.count
            };
        }

        case reportLeadsActions.ActionTypes.LOAD_FAIL: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false
            }
        }

        default: {
            return state;
        }
    }
}